var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root",attrs:{"data-testid":"activity-overlay"}},[_c('div',{class:{'background':true, 'translucent':_vm.translucent}}),_vm._v(" "),_c('circle-spinner',{attrs:{"size":"64px","color":"#2A3241","stroke":"6.4px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }